import styled, { css } from 'styled-components'
import {
  PhoneInputWrapperProps,
  CountryDropdownProps,
  CountryItemProps,
  FlagButtonProps,
} from './PhoneInput.types'
import { StyledInput } from '../Input/Input.styles'
import type { StyledInputProps } from '../Input/Input.types'

export const PhoneInputWrapper = styled.div<PhoneInputWrapperProps>`
  position: relative;
  display: ${(props) => (props.$fullWidth ? 'block' : 'inline-block')};
  width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
`

export const FlagButtonWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding-left: 12px;
  z-index: 1;
`

export const StyledPhoneInput = styled(StyledInput)<StyledInputProps>`
  padding-left: ${(props) => {
    const baseLeft =
      props.$size === 'small'
        ? '100px'
        : props.$size === 'large'
          ? '120px'
          : '110px'
    return baseLeft
  }};
`

export const FlagButton = styled.button<FlagButtonProps>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.primary};
  transition: opacity ${({ theme }) => theme.transitions.fast};

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  ${(props) =>
    props.$size === 'small' &&
    css`
      font-size: ${({ theme }) => theme.typography.fontSize.small};
    `}

  ${(props) =>
    props.$size === 'large' &&
    css`
      font-size: ${({ theme }) => theme.typography.fontSize.section};
    `}
`

export const CountryFlag = styled.span`
  font-size: 1.2em;
  line-height: 1;
  display: inline-flex;
  align-items: center;
`

export const CountryCode = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`

export const DropdownArrow = styled.span<{ $isOpen: boolean }>`
  display: inline-flex;
  align-items: center;
  transition: transform ${({ theme }) => theme.transitions.fast};
  transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  margin-left: ${({ theme }) => theme.spacing.xsmall};
`

export const CountryDropdown = styled.div<CountryDropdownProps>`
  position: absolute;
  top: calc(100% + ${({ theme }) => theme.spacing.small});
  left: 0;
  width: ${(props) => (props.$fullWidth ? '100%' : '320px')};
  max-width: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.default};
  z-index: ${({ theme }) => theme.zIndex.dropdown};
  overflow: hidden;
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`

export const SearchInputWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.small};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
`

export const CountryList = styled.div`
  max-height: 300px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border.default};
    border-radius: ${({ theme }) => theme.borderRadius.small};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.border.light};
  }
`

export const CountryItem = styled.div<CountryItemProps>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.medium};
  cursor: pointer;
  transition: background-color ${({ theme }) => theme.transitions.fast};
  font-size: ${({ theme }) => theme.typography.fontSize.body};

  ${(props) =>
    props.$isHighlighted &&
    css`
      background-color: ${({ theme }) => theme.colors.background.secondary};
    `}

  ${(props) =>
    props.$isSelected &&
    css`
      background-color: ${({ theme }) => theme.colors.primary}10;
      font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    `}

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.secondary};
  }
`

export const CountryName = styled.span`
  flex: 1;
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
